import classNames from 'classnames';

import { showSnackbar } from 'fluxo-ui';
import { CopyIcon } from 'fluxo-ui/icons';

import { frontendUrl } from '../../common/env';

interface JoinCodePanelProps {
    joinCode: string;
    compact?: boolean;
}

const joinPathPrefix = '/live-quiz/join';

const JoinCodePanel: React.FC<JoinCodePanelProps> = ({ joinCode, compact = false }) => {
    const joinUrl = `${frontendUrl}${joinPathPrefix}?code=${joinCode}`;

    const copyJoinLink = async () => {
        try {
            await navigator.clipboard.writeText(joinUrl);
            showSnackbar('Join link copied to clipboard', 'Copied', { type: 'success' });
        } catch {
            showSnackbar('Could not copy the link — select and copy it manually', 'Copy failed', { type: 'error' });
        }
    };

    return (
        <div className={compact ? 'space-y-2' : 'space-y-3'}>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Join code</p>

            <div className="flex items-center gap-2">
                <span
                    className={classNames(
                        'font-mono font-bold tracking-[0.2em] text-slate-900 dark:text-white',
                        compact ? 'text-xl' : 'text-4xl sm:text-5xl',
                    )}
                >
                    {joinCode}
                </span>
                <button
                    type="button"
                    onClick={copyJoinLink}
                    title="Copy the join link"
                    className="cursor-pointer grid place-items-center w-8 h-8 shrink-0 rounded border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white transition-colors"
                >
                    <CopyIcon className="w-4 h-4" />
                </button>
            </div>

            {!compact && (
                <p className="text-sm text-slate-500 dark:text-slate-400">
                    Players join at <span className="font-medium text-slate-700 dark:text-slate-300">{frontendUrl}{joinPathPrefix}</span>
                </p>
            )}
        </div>
    );
};

export default JoinCodePanel;
